import script from "./ChinaUSProjectDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChinaUSProjectDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ChinaUSProjectDetailPage.vue?vue&type=style&index=0&id=4a7bb09a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7bb09a"]])

export default __exports__